import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));

// DEFAULT
const Users = lazy(() => import('src/pages/dashboard/users'));
const UsersCreate = lazy(() => import('src/pages/dashboard/usersCreatePage'));
const Roles = lazy(() => import('src/pages/dashboard/roles'));
const RolesCreate = lazy(() => import('src/pages/dashboard/rolesCreatePage'));
const RelationRolService = lazy(() => import('src/pages/dashboard/RelationRolService'));
const Branches = lazy(() => import('src/pages/dashboard/branches'));
const BranchesCreate = lazy(() => import('src/pages/dashboard/branchesCreatePage'));
const Companies = lazy(() => import('src/pages/dashboard/companies'));
const CompaniesCreate = lazy(() => import('src/pages/dashboard/companiesCreatePage'));
const Advertising = lazy(() => import('src/pages/dashboard/advertising'));
const AdvertisingCreate = lazy(() => import('src/pages/dashboard/advertisingCreatePage'));
const Devices = lazy(() => import('src/pages/dashboard/devices'));
const DevicesCreate = lazy(() => import('src/pages/dashboard/devicesCreatePage'));
// Dashboards
const DashboardPrimary = lazy(() => import('src/pages/dashboard/primaryDashboard'));
const DashboardVisitantes = lazy(() => import('src/pages/dashboard/visitantesDashboard'));
const DashboardVisitas = lazy(() => import('src/pages/dashboard/visitasDashboard'));
const DashboardHeatmap = lazy(() => import('src/pages/dashboard/heatmapDashboard'));
const SchedulerPage = lazy(() => import('src/pages/dashboard/schedulerPage'));
const SensorsMonitorPage = lazy(() => import('src/pages/dashboard/sensorsMonitorPage'));

// Public
const UserAccountPage = lazy(() => import('src/pages/dashboard/account'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'users',
        children: [
          { element: <Users />, index: true,  },
          { path: 'new', element: <UsersCreate /> },
        ],
      },
      {
        path: 'roles',
        children: [
          { element: <Roles />, index: true },
          { path: 'new', element: <RolesCreate /> },
        ],
      },
      {
        path: 'Dispositivos',
        children: [
          { element: <Devices />, index: true },
          { path: 'new', element: <DevicesCreate /> },
        ],
      },
      {
        path: 'ServicioRol',
        children: [
          { element: <RelationRolService />, index: true },
        ],
      },
      {
        path: 'sucursales',
        children: [
          { element: <Branches />, index: true,  },
          { path: 'new', element: <BranchesCreate /> },
        ],
      },
      {
        path: 'empresas',
        children: [
          { element: <Companies />, index: true,  },
          { path: 'new', element: <CompaniesCreate /> },
        ],
      },
      {
        path: 'publicidad',
        children: [
          { element: <Advertising />, index: true },
          { path: 'new', element: <AdvertisingCreate /> },
        ],
      },
      {
        path: 'smartSensing',
        children: [
          { element: <DashboardPrimary />, index: true },
        ],
      },
      {
        path: 'analisisVisitantes',
        children: [
          { element: <DashboardVisitantes />, index: true },
        ],
      },
      {
        path: 'analisisVisitas',
        children: [
          { element: <DashboardVisitas />, index: true },
        ],
      },
      {
        path: 'mapaCalor',
        children: [
          { element: <DashboardHeatmap />, index: true },
        ],
      },
      {
        path: 'publicas',
        children: [
          { element: <UserAccountPage />, index: true },
        ],
      },
      {
        path: 'schedulerReportes',
        children: [
          { element: <SchedulerPage />, index: true },
        ],
      },
      {
        path: 'monitoreoSensores',
        children: [
          { element: <SensorsMonitorPage />, index: true },
        ],
      },
    ],
    
  },
];
